module.exports = __webpack_public_path__ + "static/media/invoice_retail.e3a94657.png";